<template>
    <div class="d-flex align-center flex-column">
        <v-card>
            <s-toolbar
                label="Asignación de Equipos"
                dark
                :color="'#8e8f91'"
                close
                @close="$emit('close')"
                class="mb-6"
            ></s-toolbar>
            <v-card-title style="font-size: small;">
                <v-row>
                    <v-col align="right">
                        <v-btn
                            fab
                            style="margin-right: 40px;"
                            x-small
                            color="warning"
                            @click="downloadPdf(1)"
                        >   <v-icon medium>mdi-printer</v-icon>
                        </v-btn>
                        <v-btn
                            fab
                            style="margin-right: 40px;"
                            x-small
                            color="info"
                            @click="downloadPdf(0)"
                        >   <v-icon medium>mdi-folder-google-drive</v-icon>
                        </v-btn>
                        <v-btn
                            fab
                            x-small
                            color="success"
                            @click="saveSignaturesAndFingerPrints()"
                        >   <v-icon medium>mdi-content-save</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
                <hr>
                <!-- <v-container v-if="$fun.isAdmin()" fluid class="py-1">
                    <v-row dense align="center">
                        <v-col cols="12" md="4">
                            <s-select
                                :items="supportUsers"
                                item-text="NtpFullName"
                                item-value="UsrID"
                                v-model="selectedSupportUsrID"
                                label="Técnico Responsable"
                                clearable
                                :autocomplete="true"
                                :slotTmp="true"
                                @change="onSupportUserChanged"
                            >
                                <template v-slot:item="{ item }">
                                    {{ item.NtpFullName }} - {{ item.PrsDocumentNumber }}
                                </template>
                            </s-select>
                        </v-col>
                    </v-row>
                </v-container> -->
                <vue-html2pdf
                :show-layout="true"
                :float-layout="false"
                :enable-download="false"
                :preview-modal="false"
                :filename="`Asignación.pdf`"
                :paginate-elements-by-height="1200"
                :pdf-quality="2"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="100%"
                :manual-pagination="true"
                :margin="1"
                :htmlToPdfOptions = "htmlToPdfOptions"
                @progress="onProgress($event)"
                @startPagination="startPagination()"
                @hasPaginated="hasPaginated()"
                @beforeDownload="beforeDownload($event)"
                @hasDownloaded="hasDownloaded($event)" ref="html2Pdf">
                <section slot="pdf-content">
                    <div style="font-family: Arial, Helvetica, sans-serif; width: 100%; max-width: 750px; margin: 0 auto; padding: 0 20px 15px 20px; box-sizing: border-box; font-size: 11px;">
                        <!-- Encabezado con 3 secciones -->
                        <div data-html2canvas-ignore="true" style="display: flex; width: 100%;">
                            <!-- Sección Izquierda - Logo -->
                            <div style="flex: 0.7; display: flex; justify-content: center; align-items: center;  padding: 10px;">
                                <img src="/static/logo_sp.png" alt="Logo" style="width: 140px; height: auto;">
                            </div>

                            <!-- Sección Central - Título -->
                            <div style="flex: 1.5; display: flex; justify-content: center; align-items: center;  padding: 10px; text-align: center;">
                                <h2 style="margin: 0; font-size: 13px; font-weight: bold; line-height: 14px;">ACTA DE ASIGNACIÓN DE EQUIPO INFORMÁTICO Y POLÍTICA DE USO</h2>
                            </div>

                            <!-- Sección Derecha - Información -->
                            <div style="flex: 1; font-size: 9.5px; text-align: center; border-bottom: 2px solid #000; font-weight: bold; line-height: 12px;" @dblclick="openEditModal">
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">CÓDIGO&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{formData?.codigo}}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">VERSIÓN&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{formData?.version}}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">Fecha de Creación&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{formData?.fechaCreacion}}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">Última Revisión&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{formData?.ultimaRevision}}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">Páginas&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{formData?.paginas}}</div>
                                </div>
                                <div style="display: flex; gap: 2px;">
                                    <div style="flex: 1.5; text-align: end; white-space: nowrap;">Anexo&nbsp;&nbsp;&nbsp;:</div>
                                    <div style="flex: 1; text-align: start;">{{formData?.anexo}}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Contenido principal -->
                        <div style="page-break-inside: avoid; break-inside: avoid;">
                        <p style="margin-top: 20px; margin-bottom: 16px; line-height: 12px;">
                            En conformidad con las políticas establecidas por la empresa y en cumplimiento de las normativas de seguridad de la información, se procede a la entrega del siguiente equipo informático al usuario identificado a continuación:
                        </p>
                        <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; border-radius: 2px; line-height: 14px; padding: 2px 10px;">Datos de Usuario</div>
                        <div style="display: grid; grid-template-columns: 120px 1fr 120px 1fr; width: 100%; line-height: 14px;">
                            <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Nombre</div>
                            <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{item.NtpFullName}}</div>
                            <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Usuario de Dominio</div>
                            <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{item.EanUserName}}</div>
                            
                            <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">DNI</div>
                            <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{item.PrsDocumentNumber}}</div>
                            <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Cargo</div>
                            <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{item.PstName}}</div>
                            
                            <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Área</div>
                            <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word; grid-column: span 3;">{{item.AreName}}</div>
                        </div>
                        </div>
                        <template v-for="(itemDetail) in sortedItemsDetail">
                            <!-- ========== EQUIPO ESTÁNDAR (PC / Laptop / Otros) ========== -->
                            <template v-if="itemDetail.CgeTypeEquipment != CELLPHONE_TYPE_ID">
                                <div style="page-break-inside: avoid; break-inside: avoid;">
                                <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px; margin-top: 20px;">Datos del Equipo (PC / Laptop / Otros)</div>
                                <div style="display: grid; grid-template-columns: 120px 1fr 120px 1fr; width: 100%; line-height: 14px;">
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Tipo de Equipo</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemDetail.CgeTypeEquipmentName }}</div>
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Marca</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemDetail.CgeBrandName }}</div>
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Modelo</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemDetail.CgeModelName }}</div>
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">N° Serie</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemDetail.CgeSerie }}</div>
                                </div>
                                <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px;">Detalles del Equipo</div>
                                <div style="display: grid; grid-template-columns: 120px 1fr 120px 1fr; width: 100%; line-height: 14px;">
                                    <template v-for="(itemCharacteristics) in itemDetail.ItemsCharacteristics">
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">{{ itemCharacteristics.EctCharacteristicsName }}</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemCharacteristics.EctValueCharacteristics }}</div>
                                    </template>
                                </div>
                                <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px;">Accesorios</div>
                                <template v-for="(itemAccessory) in itemDetail.ItemsAccessory">
                                    <div v-if="validatedItems(itemAccessory)" style="display: grid; grid-template-columns: 120px 60px 1fr 60px 1fr 60px 1fr; width: 100%; line-height: 14px;">
                                        <div style="background-color: #D9D9D9; font-weight: bold; padding: 2px 10px;">{{ itemAccessory.EayAccessoryName }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Marca</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemAccessory.EayBrandName }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Modelo</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemAccessory.EayModelName }}</div>
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Serie</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemAccessory.EaySerie }}</div>
                                    </div>
                                    <div v-else style="display: grid; grid-template-columns: 120px 1fr; width: 100%; line-height: 14px;">
                                        <div style="background-color: #D9D9D9; font-weight: bold; padding: 2px 10px;">{{ itemAccessory.EayAccessoryName }}</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemAccessory.EayObservation }}</div>
                                    </div>
                                </template>
                                </div>
                            </template>

                            <!-- ========== CELULAR / SMARTPHONE ========== -->
                            <template v-else>
                                <div style="page-break-inside: avoid; break-inside: avoid;">
                                <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px; margin-top: 20px;">Datos del Equipo (Celular / Smartphone)</div>
                                <div style="display: grid; grid-template-columns: 120px 1fr 120px 1fr; width: 100%; line-height: 14px;">
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Marca</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemDetail.CgeBrandName }}</div>
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Modelo</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemDetail.CgeModelName }}</div>
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">IMEI</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ itemDetail.CgeSerie || itemDetail.CgeHostname }}</div>
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">N° Celular</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ getSimAccessory(itemDetail.ItemsAccessory).EayPhoneNumber || 'No asignado' }}</div>
                                </div>

                                <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px;">Detalles del Equipo</div>
                                <div style="display: grid; grid-template-columns: 120px 1fr 120px 1fr 120px 1fr; width: 100%; line-height: 14px;">
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Procesador</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ getCharacteristic(itemDetail.ItemsCharacteristics, 1) || '-' }}</div>
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">RAM</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ getCharacteristic(itemDetail.ItemsCharacteristics, 2) || '-' }}</div>
                                    <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Almacenamiento</div>
                                    <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ getCharacteristic(itemDetail.ItemsCharacteristics, 6) || getCharacteristic(itemDetail.ItemsCharacteristics, 6) || '-' }}</div>
                                </div>

                                <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px;">Accesorios</div>
                                <div style="width: 100%; line-height: 14px; border: 1px solid #ccc;">
                                    <div style="display: grid; grid-template-columns: 110px 1fr 90px 70px 1fr; width: 100%; background-color: #D9D9D9; font-weight: bold;">
                                        <div style="padding: 2px 10px;">Accesorio</div>
                                        <div style="padding: 2px 5px;">Marca</div>
                                        <div style="padding: 2px 5px;">Potencia (W)</div>
                                        <div style="padding: 2px 0px; text-align: center;">Cable Datos</div>
                                        <div style="padding: 2px 5px;">Tipo de Cable</div>
                                    </div>
                                    <div style="display: grid; grid-template-columns: 110px 1fr 90px 70px 1fr; width: 100%;">
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">Adaptador CD</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ getChargerAccessory(itemDetail.ItemsAccessory).EayBrandName || '-' }}</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ getChargerAccessory(itemDetail.ItemsAccessory).EayWattage || '-' }}</div>
                                        <div style="padding: 2px 0px; text-align: center;">{{ getChargerAccessory(itemDetail.ItemsAccessory).EayHasDataCable ? 'Sí' : 'No' }}</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">{{ getChargerAccessory(itemDetail.ItemsAccessory).EayCableTypeName || '-' }}</div>
                                    </div>
                                    <div style="display: grid; grid-template-columns: 110px 1fr 90px 70px 1fr; width: 100%; background-color: #F9F9F9;">
                                        <div style="padding: 2px 10px; font-weight: bold; background-color: #F2F2F2;">SimCard</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                            <div><strong>Operador:</strong> {{ getSimAccessory(itemDetail.ItemsAccessory).OperatorName || '-' }}</div>
                                            <div v-if="getSimAccessory(itemDetail.ItemsAccessory).CppName"><strong>Plan:</strong> {{ getSimAccessory(itemDetail.ItemsAccessory).CppName }}</div>
                                        </div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;">
                                            <div v-if="getSimAccessory(itemDetail.ItemsAccessory).EayPhoneNumber"><strong>N°:</strong> {{ getSimAccessory(itemDetail.ItemsAccessory).EayPhoneNumber }}</div>
                                        </div>
                                        <div style="padding: 2px 0px; text-align: center;">-</div>
                                        <div style="padding: 2px 5px; word-break: break-word; overflow-wrap: break-word;"><strong>IMEI:</strong> {{ getSimAccessory(itemDetail.ItemsAccessory).EaySerie || '-' }}</div>
                                    </div>
                                </div>
                                </div>
                            </template>
                        </template>

                        <!-- Observaciones y Comentarios -->
                        <div style="page-break-inside: avoid; break-inside: avoid;">
                        <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px; margin-top: 20px;">
                            Observaciones y Comentarios
                        </div>
                        <p style="text-align: justify; padding: 2px 10px; line-height: 12px;">
                            Se realiza la entrega formal de un equipo informático<span v-if="hasCellphone"> y celular</span> en óptimas condiciones de funcionamiento. El usuario ha sido expresamente notificado de que la empresa únicamente realizará copias de respaldo automatizadas o de seguridad de los datos vinculados de manera directa a su cuenta de usuario institucional.
                        </p>
                        <div style="background-color: #F2F2F2; width: 100%; min-height: 30px; cursor: pointer; position: relative;" ref="observationContainer" @click="activateEditing">
                            <textarea
                                v-if="isEditingObservation"
                                v-model="editingObservationText"
                                style="padding: 2px 10px; border: none; min-height: 30px; width: 100%; outline: none; line-height: 14px;"
                                @click.stop
                            ></textarea>
                            <div
                                v-else
                                v-html="formattedObservationText || '<span style=color:#999;font-style:italic>Haga clic para agregar observaciones...</span>'"
                                style="padding: 2px 10px; min-height: 30px; line-height: 14px; font-size: 11px;"
                            ></div>
                        </div>
                        </div>

                        <!-- Políticas de Uso y Responsabilidades del Usuario -->
                        <div>
                            <div style="display: flex; width: 100%; background-color: #BFBFBF; font-weight: bold; padding: 2px 10px; border-radius: 2px; margin-top: 20px;">
                                Políticas de Uso y Responsabilidades del Usuario
                            </div>
                            <div style="width: 100%; text-align: justify; padding: 10px 10px 10px 30px; line-height: 12px;">
                                
                                <p style="margin-bottom: 4px;">
                                    El usuario se compromete a utilizar el equipo informático<span v-if="hasCellphone">, celular</span> y accesorios asignados por la empresa exclusivamente para fines laborales relacionados directamente con el ejercicio de su cargo.
                                </p>
                                
                                <p style="margin-bottom: 4px;">
                                    Es responsabilidad del usuario mantener los equipos y accesorios en óptimas condiciones de conservación y limpieza, evitando acciones que provoquen daños, pérdidas o el deterioro acelerado de los mismos. Asimismo, adoptará medidas preventivas para proteger la confidencialidad e integridad de la información almacenada.
                                </p>
                                
                                <p style="margin-bottom: 4px;">
                                    El usuario se obliga a respetar estrictamente las normativas de seguridad de la información corporativas, incluyendo la directiva AS-PO-008 (Política de Seguridad de la Información) que rige el correcto uso de los activos de la compañía.
                                </p>
                                
                                <p style="margin-bottom: 4px;">
                                    El colaborador deberá permitir la instalación de actualizaciones críticas de software, parches de seguridad y facilitar el mantenimiento preventivo programado por el área de TI.
                                </p>
                                
                                <p style="margin-bottom: 4px;">
                                    Se exige el empleo obligatorio de los canales seguros de la empresa (VPN corporativa) para acceder a los sistemas internos de información durante el desarrollo de jornadas bajo la modalidad de teletrabajo o trabajo remoto.
                                </p>
                                
                                <div style="margin-bottom: 4px;">
                                    <p style="margin-bottom: 4px;">
                                        <strong>Prohibiciones explícitas:</strong> Se prohíbe terminantemente al usuario realizar las siguientes acciones:
                                    </p>
                                    <ul style="margin-top: 0px; margin-bottom: 4px; padding-left: 20px;">
                                        <li>Iniciar sesión en equipos no asignados formalmente.</li>
                                        <li>Desactivar, eludir o alterar los controles y software de seguridad implementados.</li>
                                        <li>Acceder a repositorios de información no autorizados.</li>
                                        <li>Instalar aplicaciones o software pirata/no validado.</li>
                                        <li>Compartir credenciales de dominio o contraseñas con terceros.</li>
                                    </ul>
                                </div>
                                
                                <p style="margin-bottom: 4px;">
                                    En caso de robo, pérdida o daño material del equipo, el usuario deberá reportar el suceso de forma inmediata (en un plazo no mayor a 24 horas) al departamento de TI y de Recursos Humanos, colaborando activamente en el proceso de investigación o denuncia correspondiente.
                                </p>
                                
                                <div v-if="hasCellphone && sortedItemsDetail.length > 1" style="height: 20px; width: 100%; display: block;"></div>

                                    <p style="margin-bottom: 4px; page-break-inside: avoid; break-inside: avoid; display: inline-block; width: 100%;">
                                        El incumplimiento de las obligaciones dispuestas en este documento facultará a la empresa a aplicar las medidas disciplinarias, sanciones económicas o acciones legales pertinentes, de acuerdo con el Reglamento Interno de Trabajo (RIT) y la legislación laboral vigente.
                                    </p>

                                <template v-if="hasCellphone">
                                    <p style="margin-bottom: 4px; margin-top: 4px;">
                                        <strong>Uso de Smartphone Corporativo:</strong> El equipo celular y la línea móvil asignada son propiedad exclusiva de la empresa y se entregan únicamente para fines laborales. El dispositivo se mantendrá bajo la titularidad de la organización de forma indefinida mientras constituya el equipo vigente para el desarrollo de sus funciones. Queda prohibido extraer la SIM CARD para uso personal o vincular el número corporativo a cuentas bancarias, aplicaciones o redes sociales personales ajenas a la operación de la empresa.
                                    </p>
                                    
                                    <p style="margin-bottom: 2px; margin-top: 8px;">
                                        <strong>Política de Propiedad por Renovación Tecnológica:</strong> El equipo celular asignado en este acto no pasará a ser propiedad del usuario por el mero transcurso del tiempo. Únicamente en el supuesto de que el departamento de TI ejecute de manera efectiva una renovación tecnológica programada, se aplicarán las siguientes condiciones:
                                    </p>
                                    <ul style="margin-top: 0px; margin-bottom: 4px; padding-left: 20px;">
                                        <li style="margin-bottom: 4px; page-break-inside: avoid; break-inside: avoid;">
                                            <strong>Equipo Antiguo:</strong> El dispositivo sustituido pasará a ser de propiedad del usuario en el estado de conservación en que se encuentre al momento del cambio.
                                        </li>
                                        <li style="page-break-inside: avoid; break-inside: avoid;">
                                            <strong>Equipo Nuevo:</strong> El nuevo terminal asignado ingresará bajo la condición de propiedad exclusiva y restrictiva de la empresa, sujeto a las mismas políticas aquí firmadas.
                                        </li>
                                    </ul>
                                    <p style="margin-bottom: 4px;">
                                        De no producirse ninguna renovación tecnológica por decisión de TI, el equipo original continuará siendo propiedad de la empresa y deberá devolverse de manera obligatoria al cese de sus funciones.
                                    </p>
                                </template>

                                <p style="margin-bottom: 4px; margin-top: 8px;">
                                    Al concluir la relación laboral con la organización, el usuario entregará la totalidad de los activos asignados en el mismo estado en que los recibió, salvo el desgaste natural derivado del uso correcto de los mismos.
                                </p>
                                
                            </div>
                        </div>

                        <!-- <div style="page-break-inside: avoid; break-inside: avoid;"> -->
                        <p style="margin-top: 10px;">
                            En señal de total conformidad, aceptación de las cláusulas y recepción de los bienes descritos, ambas partes firman la presente acta:
                        </p>

                        <div style="display: flex; margin-top: 10px;">
                            <div style="flex: 1; margin-top: 80px; display: flex; justify-content: center;">
                                <p style="font-size: 12px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 0;">
                                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; max-width: max-content;">
                                        <div style="width: 100%; height: 80px; display: flex; justify-content: center; align-items: center; position: absolute; top: -80px;">
                                            <div style="width: 100%; display: flex;">
                                                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; cursor: pointer;" @click="funDialogSignatureUser()">
                                                    <span v-if="!EanSignatureUserAssign && !EanSignatureUserAssignDB" style="height:80px; width: 100%;"></span>
                                                    <img :src="EanSignatureUserAssign" v-if="EanSignatureUserAssign"
                                                    alt="Firma Usuario"
                                                    style="max-width: 100%; height: 80px; object-fit: contain; padding: 5px;"/>
                                                    <img :src="EanSignatureUserAssignDB" v-if="!EanSignatureUserAssign && EanSignatureUserAssignDB"
                                                    alt="Firma Usuario"
                                                    style="max-width: 100%; height: 80px; object-fit: contain; padding: 5px;"/>
                                                </div>
                                                <div style="width: 60px; height: 80px; border: 1px solid #000; text-align: center; display: flex; justify-content: center; align-items: center;">
                                                    <s-finger-print v-if="EanFingerPrintUserAssignDB && !EanFingerPrintUserAssign" contentIMG :srcImg="EanFingerPrintUserAssignDB" notBtn :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }" @fingerprintSaved="handleFingerprintUser"></s-finger-print>
                                                    <s-finger-print v-if="!EanFingerPrintUserAssignDB && !EanFingerPrintUserAssign" contentIMG notBtn :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }" @fingerprintSaved="handleFingerprintUser"></s-finger-print>
                                                    <s-finger-print v-if="EanFingerPrintUserAssign" contentIMG :srcImg="EanFingerPrintUserAssign" notBtn :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }" @fingerprintSaved="handleFingerprintUser"></s-finger-print>
                                                </div>
                                            </div>
                                        </div>
                                        <span style="border-top: 1px solid #000;min-width: 240px;">&nbsp;&nbsp;&nbsp;&nbsp; <span style="font-weight: bold;">Nombre : </span>{{ item.NtpFullName }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        <span><span style="font-weight: bold;">DNI : </span>{{ item.PrsDocumentNumber }}</span>
                                        <span><span style="font-weight: bold;">Fecha : </span>{{ this.$fun.formatDateView(item.SecCreate) }}</span>
                                    </div>
                                </p>
                            </div>
                            <div style="flex: 1; margin-top: 80px; display: flex; justify-content: center;">
                                <p style="font-size: 12px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 0;">
                                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; max-width: max-content;">
                                        <div style="width: 100%; height: 80px; display: flex; justify-content: center; align-items: center; position: absolute; top: -80px;">
                                            <div style="width: 100%; display: flex;">
                                                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; cursor: pointer;" @click="funDialogSignatureResponsible">
                                                    <span style="height:80px; width: 100%;" v-if="!EanSignatureResponsibleAssign && !EanSignatureResponsibleAssignDB"></span>
                                                    <img :src="EanSignatureResponsibleAssign" v-if="EanSignatureResponsibleAssign"
                                                    alt="Firma Responsable"
                                                    style="max-width: 80%; height: 80px; object-fit: contain; padding: 5px;" />
                                                    <img :src="EanSignatureResponsibleAssignDB" v-if="EanSignatureResponsibleAssignDB && !EanSignatureResponsibleAssign"
                                                    alt="Firma Responsable"
                                                    style="max-width: 80%; height: 80px; object-fit: contain; padding: 5px;" />
                                                </div>
                                                <div style="width: 60px; height: 80px; border: 1px solid #000; text-align: center; display: flex; justify-content: center; align-items: center;">
                                                    <s-finger-print v-if="EanFingerPrintResponsibleAssignDB && !EanFingerPrintResponsibleAssign" contentIMG :srcImg="EanFingerPrintResponsibleAssignDB" notBtn :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }" @fingerprintSaved="handleFingerprintResponsible"></s-finger-print>
                                                    <s-finger-print v-if="!EanFingerPrintResponsibleAssignDB && !EanFingerPrintResponsibleAssign" contentIMG notBtn :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }" @fingerprintSaved="handleFingerprintResponsible"></s-finger-print>
                                                    <s-finger-print v-if="EanFingerPrintResponsibleAssign" contentIMG :srcImg="EanFingerPrintResponsibleAssign" notBtn :stylesDiv="{ width: '60px', height: '80px', 'cursor': 'pointer' }" @fingerprintSaved="handleFingerprintResponsible"></s-finger-print>
                                                </div>
                                            </div>
                                        </div>
                                        <span style="border-top: 1px solid #000; min-width: 240px;">&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-weight: bold;">Nombre : </span>{{ item.UsrCreateName ? item.UsrCreateName : this.$fun.getUserInfo().NtpFullName }} &nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        <span><span style="font-weight: bold;">DNI : </span>{{ item.UsrCreatePrsDocumentNumber ? item.UsrCreatePrsDocumentNumber : this.$fun.getUserInfo().PrsDocumentNumber }}</span>
                                        <span><span style="font-weight: bold;">Fecha : </span>{{ this.$fun.formatDateView(item.SecCreate) }}</span>
                                    </div>
                                </p>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                </section>
                </vue-html2pdf>
        </v-card>
        <v-dialog v-model="dialogSignatureUser" v-if="dialogSignatureUser" max-width="800px" persistent>
            <v-card>
                <s-toolbar label="Firma del Usuario" dark color="#8e8f91" close @close="dialogSignatureUser = false"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col>
                            <s-signature-pad ref="signaturePadUser" style="height: 400px;" @save-signature="handleSignatureUser" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSignatureResponsible" v-if="dialogSignatureResponsible" max-width="800px" persistent>
            <v-card>
                <s-toolbar label="Firma del Responsable" dark color="#8e8f91" close @close="dialogSignatureResponsible = false"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col>
                            <s-signature-pad ref="signaturePadResponsible" style="height: 400px;" @save-signature="handleSignatureResponsible" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editModal" max-width="500px">
            <v-card>
                <s-toolbar label="Editar Datos del Formulario" dark color="#8e8f91"
                        close @close="editModal = false"></s-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <s-text v-model="editForm.codigo" label="Código"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.version" label="Versión"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.fechaCreacion" label="Fecha de Creación"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.ultimaRevision" label="Última Revisión"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.paginas" label="Última Revisión"></s-text>
                            </v-col>
                            <v-col cols="12">
                                <s-text v-model="editForm.anexo" label="Anexo"></s-text>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="editModal = false">Cancelar</v-btn>
                    <v-btn color="success" @click="saveFormData">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import VueHtml2pdf from 'vue-html2pdf'
    import _sHelper from "@/services/HelperService";
    import EquimentAssignamentNew from "../../../services/InformationTechnology/EquimentAssignamentNew";
    import GenUploadFiles from "../../../services/General/GenUploadFiles";
    import sFingerPrint from "@/components/Utils/RecursosHm/sFingerPrint";
    import _sGenParam from "@/services/General/ParameterService";
    import SupportUserService from "../../../services/InformationTechnology/SupportUserService";

    export default{

        props:{
            item: {
                type: Object,
                default: null,
            },
        },
        components:{
            VueHtml2pdf,
            sFingerPrint
        },
        data(){
            return{
                logoBase64: null,
                CELLPHONE_TYPE_ID: 8,
                EanSignatureUserAssign: null,
                EanFingerPrintUserAssign: null,
                EanSignatureResponsibleAssign: null,
                EanFingerPrintResponsibleAssign: null,

                EanSignatureUserAssignDB: null,
                EanFingerPrintUserAssignDB: null,
                EanSignatureResponsibleAssignDB: null,
                EanFingerPrintResponsibleAssignDB: null,

                supportUsers: [],
                selectedSupportUsrID: null,
                dialogSignatureUser: false,
                dialogSignatureResponsible: false,
                isEditingObservation: false,
                editingObservationText: "",
                htmlToPdfOptions: {
                    margin: [1.1, 0.3, 0.6, 0.3],
                    filename: `Asignación_${this.item.EanID}_a_${this.item.PrsDocumentNumber}.pdf`,
                    pagebreak: { mode: ['css', 'legacy'] },
                    jsPDF: {
                        unit: 'in',
                        format: 'a4',
                        orientation: 'portrait'
                    },
                    html2canvas: {
                        useCORS: true,
                        scale: 3,
                    },
                },
                rootFolderId: null,
                client_id: null,
                download: 1,

                formData: {},
                editForm: {
                    codigo: "",
                    version: "",
                    fechaCreacion: "",
                    ultimaRevision: "",
                    paginas: "",
                    anexo: ""
                },
                editModal: false,
                dataAttributes: {}
            }
        },
        methods:{
            openEditModal() {
                if(!this.$fun.isAdmin()) return;
                this.editForm = {...this.formData};
                this.editModal = true;
            },
            saveFormData() {
                const data = {...this.dataAttributes}
                data.PrmValue = JSON.stringify(this.editForm);
                _sGenParam.save(data, this.$fun.getUserID()).then((resp) => {
                    if (resp.status == 200) {
                        this.editModal = false;
                        this.getData();
                    }
                })
            },
            getData(){
                _sGenParam
                .listoptions({ Search: "PdfAsignation" }, this.$fun.getUserID())
                .then((resp) => {
                    if (resp.status == 200) {
                        if(!resp.data.length) return;
                        this.dataAttributes = resp.data[0];
                        this.formData = {...JSON.parse(this.dataAttributes.PrmValue)} || {};
                        console.log(resp.data[0]);
                    }
                });
            },
            loginWithGoogle(callback) {
                const client = google.accounts.oauth2.initTokenClient({
                    client_id: this.client_id,
                    scope: 'https://www.googleapis.com/auth/drive.file',
                    callback: (response) => {
                        if (response && response.access_token) {
                            this.googleAccessToken = response.access_token;
                            if (typeof callback === 'function') callback();
                        } else {
                            console.error('Fallo en login GIS', response);
                        }
                    },
                });

                client.requestAccessToken();
            },
            async uploadPdfToDrive(blob, fileName) {
                const rootFolderId = this.rootFolderId; // Carpeta principal
                const areaFolderId = await this.getOrCreateFolder(this.item.AreName, rootFolderId);

                const fileId = await this.findFileIdByName(fileName, areaFolderId);

                const metadata = fileId
                    ? { name: fileName, mimeType: 'application/pdf' }
                    : { name: fileName, mimeType: 'application/pdf', parents: [areaFolderId] };

                const form = new FormData();
                form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
                form.append('file', blob);

                const url = fileId
                    ? `https://www.googleapis.com/upload/drive/v3/files/${fileId}?uploadType=multipart`
                    : `https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart`;

                const method = fileId ? 'PATCH' : 'POST';

                try {
                    const res = await fetch(url, {
                        method,
                        headers: new Headers({ Authorization: `Bearer ${this.googleAccessToken}` }),
                        body: form
                    });

                    const json = await res.json();
                    console.log(fileId ? 'Archivo reemplazado' : 'Archivo subido nuevo', json);
                    this.$fun.alert(`¡PDF ${fileId ? 'reemplazado' : 'subido'} correctamente!`, "success");
                } catch (err) {
                    console.error('Error subiendo/reemplazando PDF:', err);
                    this.$fun.alert("Error subiendo el PDF a Drive", "error");
                }
            },
            async findFileIdByName(fileName, parentId) {
                const query = `name='${fileName}' and '${parentId}' in parents and trashed = false`;
                const res = await fetch(`https://www.googleapis.com/drive/v3/files?q=${encodeURIComponent(query)}&fields=files(id,name)`, {
                    headers: {
                        Authorization: `Bearer ${this.googleAccessToken}`,
                    },
                });

                const data = await res.json();
                return data.files?.[0]?.id || null;
            },
            async getOrCreateFolder(folderName, rootFolderId) {
                const sanitizedFolderName = folderName.replace(/[\\/#%&{}<>*? $!'":@+`|=]/g, '_').trim();

                // 1. Buscar carpeta existente
                const query = `name='${sanitizedFolderName}' and mimeType='application/vnd.google-apps.folder' and '${rootFolderId}' in parents and trashed=false`;
                const res = await fetch(`https://www.googleapis.com/drive/v3/files?q=${encodeURIComponent(query)}&fields=files(id,name)`, {
                    headers: {
                        Authorization: `Bearer ${this.googleAccessToken}`
                    }
                });

                const data = await res.json();
                if (data.files && data.files.length > 0) {
                    return data.files[0].id; // carpeta ya existe
                }

                // 2. Crear nueva carpeta
                const metadata = {
                    name: sanitizedFolderName,
                    mimeType: 'application/vnd.google-apps.folder',
                    parents: [rootFolderId]
                };

                const createRes = await fetch('https://www.googleapis.com/drive/v3/files', {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${this.googleAccessToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(metadata)
                });

                const folder = await createRes.json();
                return folder.id;
            },
            funDialogSignatureUser(){
                this.dialogSignatureUser = true;
            },
            funDialogSignatureResponsible(){
                this.dialogSignatureResponsible = true;
            },
            handleSignatureUser(image) {
                this.EanSignatureUserAssign = image;
                this.dialogSignatureUser = false;
            },
            handleSignatureResponsible(image) {
                this.EanSignatureResponsibleAssign = image;
                this.dialogSignatureResponsible = false;
            },
            handleFingerprintUser(image) {
                this.EanFingerPrintUserAssign = image;
            },
            handleFingerprintResponsible(image) {
                this.EanFingerPrintResponsibleAssign = image;
            },
            validatedItems(item) {
                if(!item.EayBrand && !item.EayModel && !item.EaySerie){
                    return false;
                }else{
                    return true;
                }
            },
            getCharacteristic(chars, typeId) {
                if (!chars) return null;
                const found = chars.find(function(c) { return c.EctCharacteristics == typeId; });
                return found ? found.EctValueCharacteristics : null;
            },
            getSimAccessory(accessories) {
                if (!accessories) return {};
                return accessories.find(function(a) { return a.EayAccessory == 14; }) || {};
            },
            getChargerAccessory(accessories) {
                if (!accessories) return {};
                return accessories.find(function(a) { return a.EayAccessory == 2; }) || {};
            },
            activateEditing(event) {
                event.stopPropagation();
                this.isEditingObservation = true;
                this.$nextTick(() => {
                    document.addEventListener("click", this.handleClickOutside);
                });
            },
            handleClickOutside(event) {
                const container = this.$refs.observationContainer;
                if (container && !container.contains(event.target)) {
                    this.isEditingObservation = false;
                    document.removeEventListener("click", this.handleClickOutside);
                }
            },
            downloadPdf(download){
                this.download = download;
                this.$refs.html2Pdf.generatePdf();
            },
            onProgress(progress) {
                this.progress = progress;
            },
            startPagination() {
            },

            hasPaginated () {
            },

            beforeDownload({ html2pdf, options, pdfContent }) {
                html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages();
                    const pageWidth = pdf.internal.pageSize.getWidth(); 
                    const pageHeight = pdf.internal.pageSize.getHeight();

                    // 1. DIBUJAR ENCABEZADO EN LAS PÁGINAS 2 EN ADELANTE
                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        
                        // Fondo blanco
                        pdf.setFillColor(255, 255, 255);
                        pdf.rect(0, 0, pageWidth, 1.05, 'F'); 

                        // Sección Izquierda - Logo
                        // Coordenadas: x: 0.5, y: 0.35, ancho: 1.4 pulgadas, alto: 0.3 pulgadas (Ajusta el alto si se ve estirado)
                        if (this.logoBase64) {
                            pdf.addImage(this.logoBase64, 'PNG', 0.5, 0.35, 1.6, 0.3);
                        }

                        // Sección Central - Título dividido en dos líneas para evitar cruces
                        pdf.setFontSize(8.5);
                        pdf.setFont('helvetica', 'bold');
                        pdf.setTextColor(0);
                        pdf.text('ACTA DE ASIGNACIÓN DE EQUIPO INFORMÁTICO', pageWidth / 2, 0.45, { align: 'center' });
                        pdf.text('Y POLÍTICA DE USO', pageWidth / 2, 0.60, { align: 'center' });

                        // Sección Derecha - Información
                        pdf.setFontSize(7);
                        pdf.setFont('helvetica', 'normal');
                        
                        let startX = pageWidth - 2.5; 
                        let startY = 0.35;
                        let gap = 0.12; 

                        pdf.text(`CÓDIGO : ${this.formData?.codigo || ''}`, startX, startY);
                        pdf.text(`VERSIÓN : ${this.formData?.version || ''}`, startX, startY + gap * 1);
                        pdf.text(`Fecha de Creación : ${this.formData?.fechaCreacion || ''}`, startX, startY + gap * 2);
                        pdf.text(`Última Revisión : ${this.formData?.ultimaRevision || ''}`, startX, startY + gap * 3);
                        pdf.text(`Páginas : ${i} de ${totalPages}`, startX, startY + gap * 4);
                        pdf.text(`Anexo : ${this.formData?.anexo || ''}`, startX, startY + gap * 5);

                        // Línea divisoria
                        pdf.setDrawColor(0);
                        pdf.setLineWidth(0.015);
                        pdf.line(0.5, 1.05, pageWidth - 0.5, 1.05);
                    }

                    // 2. NÚMEROS DE PÁGINA (Todas las hojas)
                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(100);
                        pdf.text(`Página ${i} de ${totalPages}`, pageWidth - 0.5, pageHeight - 0.20, { align: 'right' });
                    }

                    // 3. DESCARGAR O SUBIR
                    const pdfBlob = pdf.output('blob');
                    const fileName = options.filename || `Asignación_${this.item.EanID}_a_${this.item.PrsDocumentNumber}.pdf`;

                    if (this.download === 0) {
                        if (this.googleAccessToken) {
                            this.uploadPdfToDrive(pdfBlob, fileName);
                        } else {
                            this.loginWithGoogle(() => {
                                this.uploadPdfToDrive(pdfBlob, fileName);
                            });
                        }
                    } else {
                        pdf.save(fileName);
                    }
                });

                return false; 
            },
            async loadLogoBase64() {
                try {
                    const response = await fetch('/static/logo_sp.png');
                    const blob = await response.blob();
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        this.logoBase64 = reader.result;
                    };
                    reader.readAsDataURL(blob);
                } catch (error) {
                    console.error('Error cargando el logo:', error);
                }
            },
            /* loadSupportUsers() {
                const self = this;
                const requestID = this.$fun.getUserID();
                SupportUserService.listSupportUsers(requestID).then(function (resp) {
                    if (resp.status == 200) {
                        self.supportUsers = resp.data;
                        if (self.item && self.item.UsrCreateID) {
                            self.selectedSupportUsrID = self.item.UsrCreateID;
                        }
                    }
                }).catch(function (error) {
                    console.error("TicSupportUser_L: Error al cargar técnicos de soporte.", error);
                });
            },
            onSupportUserChanged(usrID) {
                if (usrID) {
                    const selected = this.supportUsers.find(function (u) { return u.UsrID == usrID; });
                    if (selected) {
                        this.$set(this.item, 'UsrCreateID', selected.UsrID);
                        this.$set(this.item, 'UsrCreateName', selected.NtpFullName);
                        this.$set(this.item, 'UsrCreatePrsDocumentNumber', selected.PrsDocumentNumber);
                    }
                } else {
                    this.$set(this.item, 'UsrCreateID', this.$fun.getUserID());
                    this.$set(this.item, 'UsrCreateName', this.$fun.getUserInfo().NtpFullName);
                    this.$set(this.item, 'UsrCreatePrsDocumentNumber', this.$fun.getUserInfo().PrsDocumentNumber);
                }
            }, */
            saveSignaturesAndFingerPrints(){
                // Use selected support user if chosen, otherwise fallback to current user
                if (this.selectedSupportUsrID) {
                    this.item.UsrCreateID = this.selectedSupportUsrID;
                } else {
                    this.item.UsrCreateID = this.$fun.getUserID();
                }
                this.item.EanObservation = this.editingObservationText;
                this.isEditingObservation = false;
                this.$fun.alert("¿Seguro de guardar?", "question")
                    .then(async r => {
                        if(r.value){

                            if (this.EanSignatureUserAssign) {
                                try {
                                    const respImg = await GenUploadFiles.upload(this.EanSignatureUserAssign, `EanSignatureUserAssign_${this.item.EanID}`, 'routeTIInfraestructura', true);
                                    this.item.EanSignatureUserAssign = respImg.data.fileName;
                                } catch (error) {
                                    this.$fun.alert("Error al subir la foto", "warning");
                                    console.error("Error al subir la foto", error);
                                }
                            }

                            if (this.EanSignatureResponsibleAssign) {
                                try {
                                    const respImg = await GenUploadFiles.upload(this.EanSignatureResponsibleAssign, `EanSignatureResponsibleAssign_${this.item.EanID}`, 'routeTIInfraestructura', true);
                                    this.item.EanSignatureResponsibleAssign = respImg.data.fileName;
                                } catch (error) {
                                    this.$fun.alert("Error al subir la foto", "warning");
                                    console.error("Error al subir la foto", error);
                                }
                            }

                            if (this.EanFingerPrintUserAssign) {
                                try {
                                    const respImg = await GenUploadFiles.upload(this.EanFingerPrintUserAssign, `EanFingerPrintUserAssign_${this.item.EanID}`, 'routeTIInfraestructura', true);
                                    this.item.EanFingerPrintUserAssign = respImg.data.fileName;
                                } catch (error) {
                                    this.$fun.alert("Error al subir la foto", "warning");
                                    console.error("Error al subir la foto", error);
                                }
                            }

                            if (this.EanFingerPrintResponsibleAssign) {
                                try {
                                    const respImg = await GenUploadFiles.upload(this.EanFingerPrintResponsibleAssign, `EanFingerPrintResponsibleAssign_${this.item.EanID}`, 'routeTIInfraestructura', true);
                                    this.item.EanFingerPrintResponsibleAssign = respImg.data.fileName;
                                } catch (error) {
                                    this.$fun.alert("Error al subir la foto", "warning");
                                    console.error("Error al subir la foto", error);
                                }
                            }

                            await EquimentAssignamentNew.save(this.item, this.$fun.getUserID());
                            this.$fun.alert("Se ha guardado correctamente", "success");
                        }
                    });
            }
        },
        computed: {
            formattedObservationText() {
                if (!this.editingObservationText) return "";
                return this.editingObservationText.replace(/\n/g, "<br>");
            },
            sortedItemsDetail() {
                if (!this.item || !this.item.ItemsDetail) return [];
                var self = this;
                return this.item.ItemsDetail.slice().sort(function(a) {
                    return a.CgeTypeEquipment == self.CELLPHONE_TYPE_ID ? 1 : -1;
                });
            },
            hasCellphone() {
                var self = this;
                return this.item && this.item.ItemsDetail && this.item.ItemsDetail.some(function(d) {
                    return d.CgeTypeEquipment == self.CELLPHONE_TYPE_ID;
                });
            },
        },
        beforeDestroy() {
            document.removeEventListener("click", this.handleClickOutside);
        },
        watch: {
            dialogSignatureUser(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.$refs.signaturePadUser?.resizeCanvas();
                    });
                }
            },
            dialogSignatureResponsible(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.$refs.signaturePadResponsible?.resizeCanvas();
                    });
                }
            }
        },
        mounted() {
            this.loadLogoBase64();
            // this.loadSupportUsers();
            console.log(this.item);
            GenUploadFiles.getFile("routeTIInfraestructura", this.item.EanSignatureUserAssign, true)
            .then(base64 => {
                this.EanSignatureUserAssignDB = base64;
            })
            .catch(error => console.error("Error al obtener imagen:", error));

            GenUploadFiles.getFile("routeTIInfraestructura", this.item.EanSignatureResponsibleAssign, true)
            .then(base64 => {
                this.EanSignatureResponsibleAssignDB = base64;
            })
            .catch(error => console.error("Error al obtener imagen:", error));

            GenUploadFiles.getFile("routeTIInfraestructura", this.item.EanFingerPrintUserAssign, true)
            .then(base64 => {
                this.EanFingerPrintUserAssignDB = base64;
            })
            .catch(error => console.error("Error al obtener imagen:", error));

            GenUploadFiles.getFile("routeTIInfraestructura", this.item.EanFingerPrintResponsibleAssign, true)
            .then(base64 => {
                this.EanFingerPrintResponsibleAssignDB = base64;
            })
            .catch(error => console.error("Error al obtener imagen:", error));

            _sGenParam
            .search({ PrmName: "rootFolderId" }, this.$fun.getUserID())
            .then((resp) => {
                if (resp.status == 200) {
                    this.rootFolderId = resp.data.PrmValue;
                    console.log(this.rootFolderId);
                }
            });

            _sGenParam
            .search({ PrmName: "client_id" }, this.$fun.getUserID())
            .then((resp) => {
                if (resp.status == 200) {
                    this.client_id = resp.data.PrmValue;
                    console.log(this.client_id);
                }
            });

            this.getData();
            this.editingObservationText = this.item.EanObservation || "";
            document.addEventListener("click", this.handleClickOutside);
        }
    }
</script>